import React, { useEffect, useState, forwardRef, useImperativeHandle } from 'react';

import { BodyPositionDisplay } from '../Processed/BodyPositionDisplay'
import api from "../../../services/api";

export const BodyPositionFetcher = forwardRef(function BodyPositionFetcher(
  { baseUrl, scale, className, wrapperClassName },
  ref
) {
  const [currentBodyPosition, setCurrentBodyPosition] = useState(null);
  const [rangeMs, setRangeMs] = useState(null);

  useImperativeHandle(ref, () => ({
    setRangeMs: (range) => {
      setRangeMs(range);
    }
  }), []);

  useEffect(() => {
    if (!rangeMs) return;

    try {
      api
        .get(`${baseUrl}/bodyposition?timeMs=${Math.round(rangeMs.min)}`)
        .then((response) => {
          let receivedData = response.data;
          setCurrentBodyPosition(receivedData.bodyPosition);
        }, (error) => {
          console.log('error', error);
          setCurrentBodyPosition(null);
        });
    } catch (error) {
      console.error('Error fetching body position:', error);
      setCurrentBodyPosition(null);
    }
  }, [rangeMs, baseUrl]);

  return (
    <>
      <BodyPositionDisplay
        bodyPosition={currentBodyPosition}
        scale={scale}
        className={className}
        wrapperClassName={wrapperClassName}
      />
    </>
  );
});
